import { instana } from "@crystal/analytics";
import { evaluateConfig } from "@crystal/core";
import { getExternalTouchpointParameters, getExternalInvitationCode, getExternalSourceId } from "../config/external-parameters.js";
import "../config/presets.js";
import { getSourceId, Scenario } from "../config/source-id-utils.js";
import { getUniversalAuthParams } from "../config/universal-auth.js";
import "react";
import "../state/reducers.js";
import "../state/actions.js";
import "../state/utils.js";
import "../store/storage/memory-storage.js";
import "mitt";
import "../store/storage/universal-memory-storage.js";
import "@reduxjs/toolkit";
import "../store/state/host.js";
import "../store/state/modal.js";
import { getRuntimeInfo, getTouchpointName } from "../integration/state-getters.js";
import "../api/email-detection.js";
import "@account/configs";
import "@crystal/glass-bridge";
import "@crystal/http";
import "@crystal/recaptcha";
import { Events } from "../monitoring.js";
import "../ap2/config.js";
import "../ap2/state.js";
import { externalAuthConfig } from "./config.js";
import { saveAuthFlow } from "./persistence.js";
import { getRedirectUrl } from "./utils.js";
import { trackSocialLoginStart } from "./analytics.js";
const createSocialLoginStarter = (flow, context) => ({
  startAuthFlow() {
    const config = evaluateConfig(externalAuthConfig);
    saveAuthFlow(flow);
    const redirectUrl = getRedirectUrl(flow.method, context, getRuntimeInfo().isAuthProvider);
    const socialLoginAuthUrl = getSocialLoginAuthUrl(flow, config, context.locale, redirectUrl);
    instana("reportEvent", Events.SocialLoginStart);
    trackSocialLoginStart(flow.provider);
    window.location.assign(socialLoginAuthUrl);
  }
});
function getSocialLoginAuthUrl({ provider, authContext, transitData }, config, locale, redirectUrl) {
  const [language, country] = locale.split("_");
  let clientId = authContext.persistentLogin ? config.persistentClientId : config.clientId;
  if (getRuntimeInfo().isAuthProvider) {
    clientId = (transitData == null ? void 0 : transitData.clientId) || getUniversalAuthParams().clientId;
  }
  const adapterid = config.providers[provider].adapter;
  const url = new URL(`${config.externalAuthServer}/as/authorization.oauth2`);
  const touchpoint = getTouchpointName();
  const touchpointParams = getExternalTouchpointParameters();
  const invitation = getExternalInvitationCode();
  const externalSourceId = getExternalSourceId();
  const sourceId = (externalSourceId == null ? void 0 : externalSourceId.sourceId) || (invitation == null ? void 0 : invitation.sourceId) || (touchpointParams == null ? void 0 : touchpointParams.sourceId) || authContext.sourceId || getSourceId(touchpoint, Scenario.Registration);
  const storeId = (touchpointParams == null ? void 0 : touchpointParams.storeId) || authContext.storeId;
  url.searchParams.set("client_id", clientId);
  url.searchParams.set("pfidpadapterid", adapterid);
  url.searchParams.set("scope", "pii accounts");
  url.searchParams.set("response_type", "code");
  url.searchParams.set("country", country);
  url.searchParams.set("language", language);
  url.searchParams.set("source", sourceId);
  url.searchParams.set("redirect_uri", redirectUrl);
  if (storeId) {
    url.searchParams.set("trck_ssmStoreId", storeId);
  }
  if (invitation == null ? void 0 : invitation.invitationCode) {
    url.searchParams.set("invitation_code", invitation.invitationCode);
  }
  return url.href;
}
export {
  createSocialLoginStarter,
  getSocialLoginAuthUrl
};
//# sourceMappingURL=social-login.js.map
